import { TAO_KOE } from './../libs';

class Download {
	static instances = [];

	constructor( containerEl ) {
		this.containerEl = containerEl;

		this.containerEl.addEventListener( 'click', ( ev ) => {
			if ( ev.target.closest( '.download-mark-all' ) ) {
				ev.preventDefault();
				this.selectAll();
			} else if ( ev.target.closest( '.download-unmark-all' ) ) {
				ev.preventDefault();
				this.unselectAll();
			}
		} );

		this.containerEl.addEventListener( 'change', ( ev ) => {
			if ( ev.target.matches( 'input.pressmedia' ) ) {
				this.onChange();
			}
		} );

		Download.instances.push( this );
	}

	selectAll() {
		this.getVisibleInputEls().forEach( ( inputEl ) => inputEl.checked = true );
		this.onChange();
	}
	unselectAll( hardReset ) {
		if ( hardReset ) {
			this.getInputEls().forEach( ( inputEl ) => inputEl.checked = false );
		} else {
			this.getVisibleInputEls().forEach( ( inputEl ) => inputEl.checked = false );
		}
		this.onChange();
	}

	onChange() {
		const inputEls = this.getVisibleInputEls();
		const checkedEls = inputEls.filter( ( inputEl ) => inputEl.checked );

		const allButtonsChecked = checkedEls.length === inputEls.length;
		this.containerEl.querySelectorAll( '.download-mark-all' ).forEach( ( buttonEl ) => buttonEl.classList.toggle( 'en_hidden', allButtonsChecked ) );
		this.containerEl.querySelectorAll( '.download-unmark-all' ).forEach( ( buttonEl ) => buttonEl.classList.toggle( 'en_hidden', ! allButtonsChecked ) );

		Download.setDownloadButton();
		Download.setUnloadListener();
	}

	getFigureEls() {
		return Array.from( this.containerEl.querySelectorAll( '.tao_presse_download_figure' ) );
	}

	getVisibleFigureEls() {
		return this.getFigureEls().filter( ( figureEl ) => ! figureEl.classList.contains( 'en_hidden' ) );
	}

	getInputEls() {
		return this.getFigureEls().reduce( ( inputEls, figureEl ) => [ ...inputEls, ...Array.from( figureEl.querySelectorAll( 'input.pressmedia' ) ) ], [] );
	}

	getVisibleInputEls() {
		return this.getVisibleFigureEls().reduce( ( inputEls, figureEl ) => [ ...inputEls, ...Array.from( figureEl.querySelectorAll( 'input.pressmedia' ) ) ], [] );
	}

	static forEachInstance( callback ) {
		Download.instances.forEach( ( instance ) => {
			callback.call( instance, instance );
		} );
	}

	static getAllInputEls() {
		let inputs = [];

		Download.forEachInstance( ( instance ) => {
			inputs = inputs.concat( instance.getInputEls() );
		} );

		return inputs;
	}

	static getCheckedInputEls() {
		return Download.getAllInputEls().filter( ( inputEl ) => inputEl.checked );
	}

	static setDownloadButton() {
		// Set Counter for Download Button.
		const count = Download.getCheckedInputEls().length;
		document.querySelectorAll( '.download-counter' ).forEach( ( countEl ) => {
			countEl.innerText = count;
		} );

		// Set Download Button abled / disabled.
		const hasCount = count > 0;
		document.querySelectorAll( '.download-trigger' ).forEach( ( triggerEl ) => {
			triggerEl.disabled = ! hasCount;
			triggerEl.classList.toggle( 'en_button--color_light', ! hasCount );
		} );
	}

	static setUnloadListener() {
		const count = Download.getCheckedInputEls().length;

		if ( count > 0 ) {
			Download.addUnloadListener();
		} else {
			Download.removeUnloadListener();
		}
	}

	static addUnloadListener() {
		window.onbeforeunload = function( event ) {
			event.preventDefault();
			event.returnValue = 'Ihre Änderungen werden eventuell nicht gespeichert.';
		};
	}

	static removeUnloadListener() {
		window.onbeforeunload = null;
	}
}

Download.init = function( scopeEl = document ) {
	// Get Multi-Download Elements.
	const containerEls = scopeEl.querySelectorAll( '.tao_presse_downloads.multi' );
	containerEls.forEach( ( containerEl ) => {
		containerEl.KOE_DOWNLOAD_HANDLER ??= new Download( containerEl );
	} );
};

TAO_KOE.ready( 'download.js', () => Download.init() );

// Expose.
TAO_KOE.Download = Download;

// Export.
export default Download;
